/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'focus-trap.scss' instead.
import { css } from 'lit';
export default css `:host{display:block}:host([hidden]){display:none}`;
//# sourceMappingURL=focus-trap.scss.js.map